import React from 'react';
import styled from 'styled-components';
import { palettes } from '@indigo-ag/component-module';

const TextWrapper = styled.div`
  width: 100%;
  font-size: 0.875rem;
  color: ${palettes.brand.gray[700]};
`;

interface TextCellProps {
  text: string;
}

const TextCell: React.FC<TextCellProps> = ({ text }) => {
  return <TextWrapper>{text}</TextWrapper>;
};

export default TextCell;
